<template>
  <sb-drawer
    :active.sync="showDrawer"
    :class="[$mq, isAdmin ? 'sb-drawer--admin' : '']"
  >
    <slot/>
  </sb-drawer>
</template>

<script>

export default {
  name: 'DrawerWrapper',
  components: {},
  mixins: [],
  props: {
    active: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    showDrawer: false
  }),
  mounted () {},
  destroyed () {},
  watch: {
    active: {
      handler (n, o) {
        if (n !== o) this.showDrawer = n
      },
      immediate: true
    },
    showDrawer (n, o) {
      this.$emit('update:active', n)
    }
  },
  computed: {
    isAdmin () {
      return this.$shipBobStore.getters['user/getUser'].isAdmin
    }
  },
  methods: {},
  directives: {},
  filters: {},
  i18n: { messages: {} }
}
</script>

<style lang='scss'>
.sb-drawer {
  &--admin {
    margin-top: 40px;
    &.sm {
      margin-top: 98px !important;
    }
  }
}
</style>
